import {
	Box,
	Heading,
	Text,
	Flex,
	IconButton,
	Input,
	useDisclosure,
	Drawer,
	DrawerCloseButton,
	DrawerContent,
	DrawerOverlay,
	DrawerHeader,
	Divider,
	Image,
	Center,
} from '@chakra-ui/react'
import React, { useState, useEffect, useCallback } from 'react'
import ChatList from '../ChatList/index'
import { MdAddCircle, MdModeEdit, MdCheckCircle } from 'react-icons/md'
import GroupUser from './GroupUser/indes'
import {
	dataLayerTagManager,
	sectionDetailedTrack,
} from '../../../../containers/repository/repo.utils'
import { GA_CATEGORY_NAVBAR } from './../../../../containers/repository/repo.utils'
import { useLanguageContext } from '../../../../context/locale.context'
import ButtonCTA from '../../../globalComponents/button'
import { TbEdit } from 'react-icons/tb'
import { GROUP_PANEL_VIEW } from '../ChatView'
import { useSharedContext } from './../../../../context/shared.context'
import { useLoadGroupParticipants } from './../../../../hooks/activity.hooks'

const GroupList = ({
	// groupUsers,
	// removeParticipant,
	// inviteUser,
	user,
	groupImage,
	chanelName,
	isopens,
	setIsopens,
	setgroupView,
	groupCreatedDatetime,
	EditFun,
	saveGroupName,
	isGroupEdit,
	setisGroupEdit,
	groupName,
	setGroupName,
}) => {
	const [selectedParticipant, setSelectedParticipant] = useState([])

	// const convertUnicode = input => {
	// 	return input.replace(/\\u(\w{4,4})/g, function (a, b) {
	// 		var charcode = parseInt(b, 16)
	// 		return String.fromCharCode(charcode)
	// 	})
	// }

	const {
		state: { chatSelectedProfile },
	} = useSharedContext()

	const { mutate: loadParticipant, data: participantData } =
		useLoadGroupParticipants()

	const initialLoad = useCallback(() => {
		loadParticipant(
			{
				activity_id: chatSelectedProfile.activity_id,
				datetime_differential: '1970-01-01 00:00:00',
				limit_value: 50,
				page_limit: 50,
				page_start: 0,
				start_from: 0,
			},
			{
				onSuccess: async data => {
					setSelectedParticipant(data)
				},
			}
		)
	}, [loadParticipant, chatSelectedProfile.activity_id])

	useEffect(() => {
		initialLoad()
	}, [initialLoad])

	const {
		state: { locale },
	} = useLanguageContext()

	const { isOpen, onOpen, onClose } = useDisclosure()

	const openCloseClick = () => {
		setIsopens(!isopens)
		setisGroupEdit(false)
		setgroupView(GROUP_PANEL_VIEW.GROUP_CHAT_VIEW)
	}

	return (
		<Drawer
			className={`form-add-onfly-drawer`}
			onClose={onClose}
			isOpen={isopens}
			placement='right'
			size='sm'
			bg='#F2F3F8'
		>
			<DrawerOverlay className={`form-add-onfly-drawer-overlay`} />
			<DrawerContent className={`form-add-onfly-drawer-content`} bg='#F2F3F8'>
				<DrawerHeader>
					<Flex mr='20px'>
						<Box flex={1}>
							<Text
								color='#000000'
								fontWeight={500}
								fontSize='18px'
								lineHeight='25px'
								fontStyle='normal'
							>
								{locale['Group Info']}
							</Text>
						</Box>
						<Box
							w='50px'
							h='18px'
							fontSize='10px'
							fontWeight='500'
							textAlign='center'
							mr='20px'
						></Box>
					</Flex>
				</DrawerHeader>

				<DrawerCloseButton
					className={`form-add-onfly-drawer-close-button`}
					color='red.600'
					border='1px solid #E1E1E1'
					borderRadius='3px'
					mt='10px'
					onClick={openCloseClick}
				/>
				<Divider />
				<Box padding='4' height={'100%'}>
					<Center display={'flex'} flexDirection='column'>
						<Image
							src={groupImage}
							h='100px'
							w='100px'
							borderRadius='50%'
							border={'2px solid #8FC8BA'}
						/>
					</Center>
					<Center mt='0.2rem'>
						{!isGroupEdit && (
							<Text fontSize={'20px'} fontWeight='900' color={'#131D0B'}>
								{chanelName}
							</Text>
						)}

						<Flex alignItems='center'>
							{!isGroupEdit ? (
								<React.Fragment>
									{user.operating_asset_first_name ===
										participantData?.[0]
											?.activity_creator_operating_asset_first_name && (
										<IconButton
											color='brand.700'
											icon={<TbEdit />}
											bg='#F2F3F8'
											onClick={EditFun}
										/>
									)}
								</React.Fragment>
							) : (
								<React.Fragment>
									<Input
										marginLeft='2'
										size='sm'
										placeholder='Enter Group Name'
										value={groupName}
										onChange={e => setGroupName(e.target.value)}
									/>
									<Text
										marginLeft='2'
										cursor='pointer'
										padding='2'
										onClick={saveGroupName}
									>
										<MdCheckCircle color='teal' />
									</Text>
								</React.Fragment>
							)}
						</Flex>
					</Center>
					<Center>
						<Text
							fontSize={'16px'}
							fontWeight='500'
							fontStyle='normal'
							color={'brand.700'}
							mb='0.6rem'
							lineHeight={'10px'}
							mt='10px'
						>
							{participantData?.length} Participants
						</Text>
					</Center>
					<Divider />

					<Center
						p='0.7rem'
						pl='0'
						fontSize={'14px'}
						fontWeight='400'
						fontStyle={'normal'}
						color={'#000000'}
					>
						<Text>Group Created by {user.operating_asset_first_name}</Text>
					</Center>
					<Center>
						<Text lineHeight={'8px'} mb='8px'>
							{'on '}
							{groupCreatedDatetime?.replace(',', ' at')}
						</Text>
					</Center>
					<Divider />
					<Heading as='h3' size='md' marginBottom='2'>
						<Flex justifyContent='space-between'>
							{user.operating_asset_first_name ===
							participantData?.[0]
								?.activity_creator_operating_asset_first_name ? (
								<Box textAlign='center'></Box>
							) : null}
						</Flex>
					</Heading>
					<Box height='82%' overflowY='auto'>
						<GroupUser
							groupUsers={participantData}
							selectedParticipant={selectedParticipant}
							setSelectedParticipant={setSelectedParticipant}
							user={user}
							openCloseClick={openCloseClick}
							initialLoad={initialLoad}
						/>
					</Box>
				</Box>
			</DrawerContent>
		</Drawer>
	)
}

export default GroupList
